import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNotification } from "../../context/NotificationContext";
import { NotificationItem } from "./NotificationItem";

export const NotificationContainer: React.FC = () => {
  const { notifications } = useNotification();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted || notifications.length === 0) {
    return null;
  }

  return createPortal(
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 z-[2147483647] flex items-end px-4 py-6 sm:items-start sm:p-6"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {notifications.map((notification) => (
          <NotificationItem key={notification.id} notification={notification} />
        ))}
      </div>
    </div>,
    document.body
  );
};
